import { IQuestion, IQuestionCategory, IQuestionEvent } from '@/domain/suppliers'

export const isFetching = (state: any, isFetching: boolean) => {
    state.isFetching = isFetching;
}

export const allLibraryQuestions = (state: any, questions: IQuestion[]) => {
    state.allLibraryQuestions = questions;
}

export const selectedQuestion = (state: any, question: IQuestion) => {
    state.selectedQuestion = question;
}

export const questionHistory = (state: any, history: IQuestionEvent[]) => {
    state.questionHistory = history;
}

export const allTags = (state: any, tags: string[]) => {
    state.allTags = tags;
}

export const allCategories = (state: any, categories: IQuestionCategory[]) => {
    state.allCategories = categories;
}
